<template>
  <div class="search-wrap">
    <div class="search-input" v-if="mode === 'input'">
      <input placeholder="点击搜索" @click="goSearch" />
    </div>

    <div class="line-search-wrap" v-else-if="mode === 'line-input'">
      <div class="line-search-box" @click="goSearch">
        <div class="search-pa search-icon">
          <img class="image" src="./assets/line-search-icon.png" />
        </div>
        <div class="search-pa search-text">{{searchText}}</div>
      </div>
    </div>

    <div class="search-icon" @click="goSearch" v-else>
      <img :src="searchIcon" />
    </div>

    <search v-if="isShow" :show="isShow" @close="close"/>
  </div>
</template>

<script>
import { ensure_protocol } from '@beastshop/url-util'  
import search from './components/main'

const searchIcon = ensure_protocol('http://img.thebeastshop.com/images/menu-tab/menu-search.png')

export default {
  components: {
    search
  },

  props: ['mode', 'searchText', 'show'],

  data () {
    return {
      searchIcon: searchIcon,
      isShow: false
    }
  },

  watch: {
    show (val) {
      sa.setCurrentPage('搜索页')
      if (val) {
        this.isShow = true
      }
      else {
        this.isShow = false
      }
    }
  },

  methods: {
    goSearch (e) {
      this.isShow = true
      this.$emit('showsearch')
      sa.track('SearchButtonClick', {})
      sa.setCurrentPage('搜索页')
    },

    close () {
      this.isShow = false
      this.$emit('hidesearch')
    }
  }

}
</script>

<style lang="stylus">
@import './index.styl'
</style>



// WEBPACK FOOTER //
// index.vue?c957799e